module.exports = "<app-titlebar></app-titlebar> <!--(EnvSelected)=\"onEnvSelected($event)\"-->\n<router-outlet></router-outlet>"